import { Field } from 'formik'
import React from 'react'

import { Input, Textarea } from '@fourthwall/components'

import * as S from './BasicTab.styled'

export const BasicTab = () => {
  return (
    <S.FormFields>
      <Field component={Input} name="name" label="Section Name" placeholder="Enter section name" />
      <Field
        component={Textarea}
        name="description"
        label="Description (optional)"
        placeholder="Enter section description"
        rows={3}
      />
      <Field
        component={Input}
        name="url"
        label="Iframe URL"
        placeholder="https://example.com/embed"
      />
    </S.FormFields>
  )
}
